"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Loader", {
  enumerable: true,
  get: function () {
    return _Loader.default;
  }
});
Object.defineProperty(exports, "LoaderStyled", {
  enumerable: true,
  get: function () {
    return _Loader2.Container;
  }
});

var _Loader = _interopRequireDefault(require("./Loader"));

var _Loader2 = require("./Loader.styles");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTG9hZGVyL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgYXMgTG9hZGVyIH0gZnJvbSAnLi9Mb2FkZXInXG5leHBvcnQgeyBDb250YWluZXIgYXMgTG9hZGVyU3R5bGVkIH0gZnJvbSAnLi9Mb2FkZXIuc3R5bGVzJ1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBIn0=